import React from 'react';
import PageFooter from 'components/layout/pageFooter.jsx';
import Pagination from 'components/layout/pagination.jsx';

import Loader from 'components/loader.jsx';
import {FormattedMessage} from 'react-intl';


let EncyclopediaResults = ({
    baseUrl, items, count, query, pageSize, page, onResultClick,
    onPageChange, formatMessage,
}) => {
  let loaded = !!items;

  return (
    <Loader loaded={loaded}>
      <div className='encyclopedia-results-container'>
        {!!query ?
          <p className='encyclopedia-summary'>
            <strong><FormattedMessage id="encyclopedia.search.returned" /> <span style={{fontSize: '1.2em'}}>{count}</span> <FormattedMessage id="encyclopedia.results.for" /> "{query.trim()}"</strong>
          </p> : null}

        {(items || []).map((article) =>
          <div className='encyclopedia-result'>
            <h3 className={'title'}><a href={'#encyclopedia/' + article.id}>{article.title} {article.fav ? <i className='sr-fav star icon bl bl-star-filled'/> : null}</a></h3>
            <p className='description'>{article.namedPath ? `${article.namedPath} ${article.description && '|'} ` : ''}{article.description}</p>
          </div>
                )}

        <PageFooter className='tc'>
          <Pagination baseUrl={baseUrl} page={page} count={pageSize} total={count} onPageChange={onPageChange} />
        </PageFooter>
      </div>
    </Loader>
  );
};

export default EncyclopediaResults;
